
import CannedResponseTitle from './CannedResponseTitle';
import CannedResponseGroup from './CannedResponseGroup';

function parseCannedResponseTitle(title) {
  const isContainsGroups = title[0] === '['
  if (!isContainsGroups) return [undefined, title]

  const groupEndIndex = title.indexOf(']')
  let groups = title.slice(1, groupEndIndex)
  groups = groups.split('/')
  groups = groups.map(group => group.trim())
  return [groups, title.slice(groupEndIndex + 1)]
}

function buildCannedResponseTreeRec(groups, title, parentStorage, cannedResponse) {
  if (!groups || !groups.length) {
    return parentStorage.push(new CannedResponseTitle(title, cannedResponse.id, cannedResponse.text));
  }

  const groupName = groups.shift()
  const groupFromParentStorage = parentStorage.filter(item => item.name === groupName)[0]
  if (groupFromParentStorage) {
    buildCannedResponseTreeRec(groups, title, groupFromParentStorage.data, cannedResponse)
  } else {
    const cannedResponseGroup = new CannedResponseGroup(groupName)
    parentStorage.push(cannedResponseGroup);
    buildCannedResponseTreeRec(groups, title, cannedResponseGroup.data, cannedResponse)
  }
}

function parseCannedResponse(cannedResponseArray) {
  const titles = [];

  cannedResponseArray.forEach(cannedResponse => {
    const [groups, title] = parseCannedResponseTitle(cannedResponse.title)
    buildCannedResponseTreeRec(groups, title, titles, cannedResponse)
  });

  return titles
}

export default parseCannedResponse
